import { IRecall } from "../@types/recalls";
import axiosInstance from "../utils/axios";

export class RecallsService {
  createRecall(data: Partial<IRecall>) {
    return axiosInstance.post(`/recalls`, data);
  }

  getRecalls() {
    return axiosInstance.get<IRecall[]>(`/recalls`);
  }

  sendRecall(id: number) {
    return axiosInstance.post(`/recalls/${id}/send`);
  }

  sendAllRecalls(communicationType?: string) {
    const url = communicationType
      ? `/recalls/send-all?communicationType=${encodeURIComponent(communicationType)}`
      : `/recalls/send-all`;
    return axiosInstance.post(url);
  }

  updateStage(id: number) {
    return axiosInstance.put(`/recalls/${id}/stage`);
  }

  deleteRecall(id: number) {
    return axiosInstance.delete(`/recalls/${id}`);
  }

  updateRecall(id: string, data: Partial<IRecall>) {
    return axiosInstance.put(`/recalls/${id}`, data);
  }

  /**
   * @deprecated [DEV-ONLY] This is a manual trigger for the Cron Job.
   * TODO: Remove this from frontend once the server-side CRON scheduler is configured.
   */
  triggerDailyStaging() {
    return axiosInstance.post(`/recalls/cron/daily`);
  }

  /**
   * @deprecated [DEV-ONLY] This is a manual trigger for the Cron Job.
   * TODO: Remove this from frontend once the server-side CRON scheduler is configured.
   */
  triggerSafetyNet() {
    return axiosInstance.post(`/recalls/cron/safety-net`);
  }

  getAnalytics() {
    return axiosInstance.get(`/recalls/analytics`);
  }
}
